import React, { useState } from 'react';
import adminServices from '../../../Services/makeAdmin';
import Swal from 'sweetalert2';
import './CustomizeHomePage.css';

const CustomizeHomePage = () => {
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if (!content.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Validation Error',
                text: 'Please enter homepage content before submitting.',
                confirmButtonColor: '#5e71f6',
            });
            return;
        }

        setIsSubmitting(true);

        const homePageData = {
            homePageMassage: content
        };

        try {
            const res = await adminServices.UpdateHomeMassage(homePageData);
            if (res) {
                Swal.fire({
                    icon: 'success',
                    title: 'Updated!',
                    text: 'Homepage content has been updated successfully!',
                    confirmButtonColor: '#5e71f6',
                });
                setContent('');
            } else {
                throw new Error('Update failed');
            }
        } catch (error) {
            console.error('Error updating homepage:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Failed to update homepage content. Please try again.',
                confirmButtonColor: '#5e71f6',
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="customize-homepage-wrapper">
            <div className="customize-homepage-container">
                {/* Header Section */}
                <div className="customize-homepage-header">
                    <h1 className="customize-homepage-title">Customize Homepage</h1>
                    <p className="customize-homepage-subtitle">Update the main content displayed on the homepage</p>
                </div>

                {/* Form Card */}
                <div className="homepage-form-card">
                    <div className="homepage-form-header">
                        <h2 className="form-card-title">
                            <svg className="form-header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Homepage Content Editor
                        </h2>
                    </div>

                    <form onSubmit={handleSubmit} className="homepage-form">
                        <div className="form-field">
                            <label className="form-label">
                                <svg className="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                Homepage Message <span className="required-mark">*</span>
                            </label>
                            <div className="textarea-container">
                                <textarea
                                    name="homeContent"
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    placeholder="Enter the message or content to display on the homepage..."
                                    className="form-textarea"
                                    rows="12"
                                    required
                                ></textarea>
                                <div className="character-counter">
                                    <svg className="counter-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    {content.length} characters
                                </div>
                            </div>
                        </div>

                        {/* Info Box */}
                        <div className="info-box">
                            <svg className="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <div className="info-content">
                                <strong>Tip:</strong> This content will be displayed prominently on the homepage. Make it engaging and informative to welcome visitors to your conference.
                            </div>
                        </div>

                        {/* Submit Button */}
                        <button 
                            type="submit" 
                            className="submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <svg className="button-icon spinner" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                    Updating...
                                </>
                            ) : (
                                <>
                                    <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Update Homepage Content
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CustomizeHomePage;